import React, { useState, useEffect } from "react";

const OnlineBookingCommunity = () => {
  const mobNum = localStorage.getItem("moblie");

  var [tit, setTit] = useState("");
  var [firstName, setFirstName] = useState("");
  var [middleName, setMiddleName] = useState("");
  var [lastName, setLastName] = useState("");
  var [fatherName, setFatherName] = useState("");
  var [aadhaarNo, setAadhaarNo] = useState("");
  var [mobileNo, setMobileNo] = useState("");
  var [panNo, setPanNo] = useState("");
  var [email, setEmail] = useState("");
  var [gender, setGender] = useState("");
  var [dob, setDob] = useState("");
  var [addressUser, setAddressUser] = useState("");

  return (
    <>

<div className="card shadow myprofileCard ">
        <div className="card-body overFlow p-md-3">


      <div className="row justify-content-around ">
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Name Of Applicant:
            </label>
            <input
              type="mobile"
              id="aadhaarcard"
              onChange={(e) => setFirstName(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Mobile Number:
            </label>
            <input
              type="mobile"
              // onChange={(e) => setMobileNo(e.target.value)}
              value={mobNum}
              disabled
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Aadhaar Number:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setAadhaarNo(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>

        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Pancard Number:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setPanNo(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3 ">
            <label className="form-label" for="id">
              Email:
            </label>
            <input
              type="mobile"
              //   onChange={(e) => setEmail(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Pin Code:
            </label>
            <select
              className="form-control form-select"
              onChange={(e) => setGender(e.target.value)}
            >
              <option value="none">Select Pincode</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Trans">Transgender</option>
            </select>
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              DOB:
            </label>
            <input
              type="date"
              //   onChange={(e) => setDob(e.target.value)}
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Booking Area Type
            </label>
            <input
              type="mobile"
              // onChange={(e) => setMobileNo(e.target.value)}
              //   value={mobNum}
              //   disabled
              className="form-control"
              placeholder="Enter here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Address:
            </label>
            <input
              type="mobile"
              onChange={(e) => setAddressUser(e.target.value)}
              className="form-control"
              placeholder="write your full address here"
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-outline mb-3">
            <label className="form-label" for="id">
              Zone:
            </label>
            <select
              className="form-control "
              onChange={(e) => setGender(e.target.value)}
            >
              <option value="none">Select Zone</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Trans">Transgender</option>
            </select>
          </div>
        </div>
        <div className="col-4">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  GSTIN(If any):
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setAddressUser(e.target.value)}
                  className="form-control"
                  placeholder="write your full address here"
                />
              </div>
            </div>
      </div>
      </div>
      </div>
      
    </>
  );
};
export default OnlineBookingCommunity;
